export default "https://assets.pclncdn.com/web/next-landing/01bc7bc/_next/static/images/cobrand-retailmenot-promo-f3133995ab5595df5c2d6da75380415e.jpg";